/**
 * Extractores de datos estandarizados
 * Evita duplicación al normalizar respuestas de API
 */

/**
 * Extrae un array de comentarios de diferentes estructuras
 * @param {*} data - Datos del API
 * @returns {Array} Array de comentarios
 */
export const extractCommentaryArray = (data) => {
  if (Array.isArray(data)) return data;
  if (data?.commentary && Array.isArray(data.commentary)) return data.commentary;
  if (data) return [data];
  return [];
};

/**
 * Extrae un array de estadísticas de diferentes estructuras
 * @param {*} data - Datos del API
 * @returns {Array} Array de estadísticas
 */
export const extractStatsArray = (data) => {
  if (Array.isArray(data)) return data;
  if (data?.stats && Array.isArray(data.stats)) return data.stats;
  return [];
};
